import { Component, Input } from 'angular-ts-decorators';

/**
 * #swCard
 *
 * Component that displays a card.
 *
 * # Example
 * <pre>
 * <sw-card>
 *   <sw-card-header>
 *     Header content
 *   </sw-card-header>
 *
 *   <sw-card-subheader>
 *     Subheader content
 *   </sw-card-subheader>
 *
 *   <sw-card-main>
 *     Main content
 *   </sw-card-main>
 *
 *   <sw-card-footer>
 *     Footer content
 *   </sw-card-footer>
 * </sw-card>
 * </pre>
 */
@Component({
  selector: 'swCard',
  transclude: {
    swCardHeader: '?swCardHeader',
    swCardSubheader: '?swCardSubheader',
    swCardMain: '?swCardMain',
    swCardFooter: '?swCardFooter',
  },
  template: require('./sw-card.html').default,
})
export class SwCardComponent {
  @Input('@') color: string;
  @Input() fullWidth: boolean;
  @Input() mainFullWidth: boolean;
  isCardExpanded: boolean = false;

  constructor() {
    'ngInject';
  }

  private getCardExpanded(): string {
    return this.isCardExpanded ? 'sw-card--expanded' : '';
  }

  private getFullWidth(): string {
    return this.fullWidth ? 'sw-card--full-width' : '';
  }

  expandToggle(): void {
    this.isCardExpanded = !this.isCardExpanded;
  }

  getColor(color: string = 'none'): string {
    return `sw-card--${color}`;
  }

  getClasses(): string {
    return `${this.getColor(
      this.color,
    )} ${this.getFullWidth()} ${this.getCardExpanded()}`;
  }

  getMainClasses(): string {
    return this.mainFullWidth ? 'sw-card__main--full-width' : '';
  }
}
